import React, { PropsWithChildren } from "react";
import { Close } from "../_icons/Close.tsx";
import styles from "./Chip.module.css";

export const Chip: React.FC<PropsWithChildren<{ onDelete?: () => void }>> = (
  props,
) => (
  <span className={styles.Chip}>
    {props.children}{" "}
    {props.onDelete && (
      <span
        className={styles.Delete}
        onClick={(e) => {
          e.stopPropagation();
          props.onDelete?.();
        }}
      >
        <Close />
      </span>
    )}
  </span>
);
